var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"token-offerings"},[_c('carousel',{attrs:{"navigationEnabled":true,"navigation-next-label":"","navigation-prev-label":"","paginationEnabled":false,"scrollPerPage":false,"perPageCustom":[
            [320, 1.3],
            [400, 1.7],
            [450, 1.8],
            [525, 2.2],
            [600, 2.5],
            [768, 1.8],
            [900, 2.2],
            [1000, 2.5],
            [1150, 3.5],
            [1300, 3.5],
            [1400, 4],
            [1500, 4.5],
            [1600, 5],
            [1800, 6]
        ]}},_vm._l((_vm.ids),function(tokenOffering,index){return _c('slide',{key:index},[_c('token-offering-tile',{attrs:{"id":("token-tile-" + index),"token-offering-id":tokenOffering}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }